import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateFromUrlModalActive } from "../../../../redux/slices/preview";

export default function FromUrlBtn() {
   const { selectedUserActivity, userActivities, history } = useSelector((state) => state.userActivity);

   const dispatch = useDispatch();

   const handleClick = async (e) => {
      // console.log(e.target.files[0])
      dispatch(updateFromUrlModalActive({fromUrlModalActive: true}))
   }

   return (
      <div className="reset-canvas center-y" style={{ marginLeft: '1rem' }}>
         <button onClick={handleClick} 
         style={{ fontSize: '1rem', paddingLeft: '20px', paddingRight: '20px' }} >
            From Url
         </button>
      </div>
   );
}
